// extracted by mini-css-extract-plugin
export default {"root":"error_root__90iUK","label":"error_label__OMFE9","title":"error_title__buKj0","description":"error_description__HlRnT"};